import { typedQuery } from "../../../typed-query";

export type CaseStudyLink = {
  name: string | null;
  slug: string | null;
  site: string | null;
  _updatedAt: string;
  stats: { label: string; value: string }[] | null;
};

export type CaseStudyLinksResult = CaseStudyLink[];

/**
 * Lightweight lookup of every case study's name, slug, site, last-updated
 * time (for dedup when a company has >1 doc), and lead stats. Powers logo
 * wall deep-links; `site` drives cross-site URLs via `getCaseStudyHref`.
 */
export const caseStudyLinksQuery = typedQuery<CaseStudyLinksResult>(`
*[_type == "sharedCaseStudy" && defined(slug) && defined(company->name)] {
  "name": company->name,
  "slug": coalesce(slug.current, slug),
  site,
  _updatedAt,
  "stats": stats[0..2]{ label, value },
}
`);
